import { RootState } from '../store';

export const getAuthenticatedUserDetails = (state: RootState) => state.user;
export const getAuthenticatedUserId = (state: RootState) => state.user.id;
export const getAuthenticatedUserName = (state: RootState) => state.user.name;
export const getAuthenticatedUserEmail = (state: RootState) => state.user.email;
export const getUserCurrentlyWorkingBrandId = (state: RootState) =>
    state.user.currentlyWorkingBrandId;
export const getApiStatus = (state: RootState) => state.user.apiStatus;
